import { stellateQuery } from '@/helpers/graphql_modules/stellate';
import { UndergradModule } from '@/models/undergrad/undergrad-module.model';
import { getSubmodulesByIdList } from '@/store/queries/stellate.queries';

export class StellateSubmodulesReaderService {
  public static async getSubmodulesByIdList(submoduleIds: string[]): Promise<UndergradModule[]> {
    const {
      data: { faculModules },
    } = await stellateQuery(getSubmodulesByIdList, { submoduleIds });

    return faculModules;
  }
}
